/* Acceptable Format for TimepickerV2 value is '2021-09-01T12:00:00.000'
to make it work properly
and onChange it will return the same format.
*/
import { DateTime } from 'luxon';
import { JSX, JSXElement, mergeProps } from 'solid-js';
import './index.css';
import { TextField } from '@atgfr8/atg-ui-tailwind';

export type TimepickerProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string | JSXElement;
  error?: string | string[] | null;
  class?: string;
  sxProps?: JSX.CSSProperties;
  disabled?: boolean;
  isUTC?: boolean;
  dataTestId: string;
  inputProps?: {
    'aria-label'?: string;
  };
};

export const TimePicker = (props: TimepickerProps) => {
  props = mergeProps(
    {
      fullWidth: true,
    },
    props,
  );

  const formatTime = (value: string) => {
    if (!value) return '';
    const date = DateTime.fromISO(value);
    return date.isValid ? date.toFormat('T') : '';
  };

  const reverseFormatTime = (time: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if ((time?.trim() ?? '').length === 0) {
      return '';
    }

    const dateParts = props.value
      ? props.value.split('T')
      : DateTime.now().toISO().split('T');
    return `${dateParts[0]}T${time ? time : ''}`;
  };

  return (
    <TextField
      type="time"
      {...props}
      {...((props.inputProps ?? {}) as Record<string, unknown>)}
      value={formatTime(props.value)}
      dataTestId={props.dataTestId}
      onChange={(value: string) => {
        props.onChange(reverseFormatTime(value));
      }}
      onClick={(e) => {
        if (props.disabled) {
          return;
        }

        const input = e.currentTarget as HTMLInputElement;
        const iconClickZoneWidth = 36;
        const clickOffsetX = e.clientX - input.getBoundingClientRect().left;
        const clickedIconZone =
          clickOffsetX >= input.clientWidth - iconClickZoneWidth;

        if (!clickedIconZone) {
          return;
        }

        if (typeof input.showPicker === 'function') {
          input.showPicker();
        }
      }}
      class={`timepicker-custom ${props.class ?? ''}`.trim()}
      label={props.label}
      error={
        props.error !== undefined &&
        props.error !== null &&
        props.error.length > 0
          ? props.error[0]
          : ''
      }
    />
  );
};
